define('../src/js/GamedayScaffold',['require','exports','module','jquery','./ensureGameParams','gameday-index-configurator/GamedayIndexConfigurator','message-service/message-service','gameday-index-gdapp/GDIndexAppComponent','gameday-index-gdscoreboard/GDIndexScoreboardComponent','gameday-index-gdaudio/GDIndexAudioComponent','gameday-index-footer/GDIndexFooterComponent','gameday-index-loginifame/GDIndexLoginIframeComponent','gameday-index-gdcalendar/GDIndexCalendarComponent','gameday-index-mlbtv/GDIndexMlbtv','gameday-index-gdtracking/GDIndexTrackingComponent','gameday-index-gdads/GDIndexAdsComponent','gameday-index-enums/enums/events/LoadEvents','extant/extant','app-console/app-console'],function(require, exports, module) {

	// require components
	var $ = require("jquery"),
		ensureGameParams = require( "./ensureGameParams" ),
		configMngr = require("gameday-index-configurator/GamedayIndexConfigurator"),
		dispatcher = require("message-service/message-service"),
		GDApp = require("gameday-index-gdapp/GDIndexAppComponent"),
		GDScoreboard = require("gameday-index-gdscoreboard/GDIndexScoreboardComponent"),
		GDAudio = require("gameday-index-gdaudio/GDIndexAudioComponent"),
		GDFooter = require("gameday-index-footer/GDIndexFooterComponent"),
		GDLoginIframe = require("gameday-index-loginifame/GDIndexLoginIframeComponent"),
		GDCalendar = require("gameday-index-gdcalendar/GDIndexCalendarComponent"),
		GDMlbtv = require("gameday-index-mlbtv/GDIndexMlbtv"),
		TrackingManager = require("gameday-index-gdtracking/GDIndexTrackingComponent"),
		AdEngine = require("gameday-index-gdads/GDIndexAdsComponent"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		//GameSwitchMediator = require("responsive-gameday-game-switch-mediator/responsive-gameday-game-switch-mediator"),
		exists = require("extant/extant"),
		logg = require("app-console/app-console");

	// instance variables
	var vrs = "RC5::" + window.buildNum,
		componentInitInt = 0;

	exports.init = function(site, gameday, skin, components) {
		// model-ize the configs
		logg.config({ ns: "IDX" });
		configMngr.init(site, gameday, skin, components);
		ensureGameParams();
		dispatcher.addListener.call(this, LoadEvts.componentReady, this.handleComponentReady);

		setPageListener();
		initComponents(configMngr.getBuildManifest());
		

	};

	exports.handleComponentReady = function() {
		componentInitInt--;
		if (componentInitInt === 0) {
			dispatcher.publish(LoadEvts.pageReady);
		}
	};


	function setPageListener() {
		var listener = configMngr.getInitListener();

		if (exists(listener, "event,handler")) {
			dispatcher.one(listener.event, listener.handler);
		}
	}

	/**
	 * Function initComponents
	 * @param {object}
	 */
	function initComponents(manifest) {
		//set component init count
		for (var item in manifest) {
			componentInitInt++;
		}
		
		for (var prop in manifest) {
			switch(prop) {
				case "header":
					// header will be in bower_components once built
					// new Header(prop, manifest[prop]);
					logg.log("add header component");
					break;
				case "tv":
					new GDMlbtv(prop, manifest[prop]);
					break;
				case "tracking":
					new TrackingManager(prop, manifest[prop]);
					logg.log("add tracking component");
					break;

				case "ads":
					new AdEngine(prop, manifest[prop]);
					logg.log("add advertising component");
					break;

				case "scoreboard":
					new GDScoreboard(prop, manifest[prop]);
					logg.log("add scoreboard component");
					break;

				case "audio":
					new GDAudio(prop, manifest[prop]);
					logg.log("add mr. gd audio manager");
					break;

				case "calendar":
					new GDCalendar(prop, manifest[prop]);
					logg.log("add calendar / wdate picker component");
					break;

				case "app":
					new GDApp(prop, manifest[prop]);
					logg.log("add application component");
					break;

				case "viewTypeLinks":
					// new ViewLinks(prop, manifest[prop]);
					logg.log("add view control links component");
					break;

				case "footer":
					new GDFooter(prop, manifest[prop]);
					logg.log("add footer component");
					break;
					
				case "loginiframe":
					new GDLoginIframe(prop, manifest[prop]);
					logg.log("add login iframe component");
					break;					

			}
		}
	}
});
